(function () {
  "use strict";

  var cartSyncTimer = null;

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function cartRoute(path) {
    var root =
      window.Shopify && Shopify.routes && Shopify.routes.root
        ? Shopify.routes.root
        : "/";

    return root + String(path || "").replace(/^\//, "");
  }

  function ensureThemeFallbackStores() {
    if (!window.Alpine || typeof Alpine.store !== "function") return;

    try {
      if (!Alpine.store("xPopupInsurance")) {
        Alpine.store("xPopupInsurance", {
          loading: false,
          openInsuranceNoti: false,

          openInsuranceNotification: function () {
            this.openInsuranceNoti = true;
          },

          closeInsuranceNotification: function () {
            this.openInsuranceNoti = false;
          },
        });
      }
    } catch (error) {
      console.warn("Unable to initialize insurance store:", error);
    }
  }

  function getCartSectionsToRender() {
    if (window.Alpine && Alpine.store) {
      try {
        var helper = Alpine.store("xCartHelper");

        if (helper && typeof helper.getSectionsToRender === "function") {
          var helperSections = helper.getSectionsToRender();

          if (helperSections && helperSections.length) {
            return helperSections;
          }
        }
      } catch (error) {
        console.warn("Unable to get cart sections:", error);
      }
    }

    return [
      {
        id: "cart-icon-bubble",
        selector: "#cart-icon-bubble",
      },
      {
        id: "mobile-cart-icon-bubble",
        selector: "#mobile-cart-icon-bubble",
      },
      {
        id: "cart-icon-bubble-mobile-dock",
        selector: "#cart-icon-bubble-mobile-dock",
      },
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
    ];
  }

  function getSectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    var target = doc.querySelector(selector);

    return target ? target.innerHTML : "";
  }

  function reRenderCartSections(sections) {
    if (!sections) return Promise.resolve();

    ensureThemeFallbackStores();

    if (window.Alpine && Alpine.store) {
      try {
        var helper = Alpine.store("xCartHelper");

        if (helper && typeof helper.reRenderSections === "function") {
          return Promise.resolve(helper.reRenderSections(sections));
        }
      } catch (error) {
        console.warn("Unable to re-render cart sections:", error);
      }
    }

    getCartSectionsToRender().forEach(function (sectionToRender) {
      if (
        !sectionToRender ||
        !sectionToRender.id ||
        !sections[sectionToRender.id]
      ) {
        return;
      }

      String(sectionToRender.selector || "")
        .split(",")
        .forEach(function (selector) {
          selector = selector.trim();

          if (!selector) return;

          var sectionElement = document.querySelector(selector);

          if (!sectionElement) return;

          var html = getSectionInnerHTML(
            sections[sectionToRender.id],
            selector,
          );

          if (html) {
            sectionElement.innerHTML = html;
          }
        });
    });

    return Promise.resolve();
  }

  function publishCartEvents(cartData) {
    ensureThemeFallbackStores();

    document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));

    document.dispatchEvent(new CustomEvent("cart:refresh"));

    document.body.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
      }),
    );

    document.body.dispatchEvent(
      new CustomEvent("cart:updated", {
        bubbles: true,
        detail: {
          cart: cartData || null,
        },
      }),
    );

    if (
      window.FFLZipCheckout &&
      typeof window.FFLZipCheckout.refresh === "function"
    ) {
      window.setTimeout(function () {
        window.FFLZipCheckout.refresh();
      }, 50);
    }
  }

  function openCartDrawer() {
    ensureThemeFallbackStores();

    document.dispatchEvent(new CustomEvent("cart:open"));
    document.dispatchEvent(new CustomEvent("cart-drawer:open"));
    document.dispatchEvent(new CustomEvent("theme:cart:open"));

    if (window.Alpine && Alpine.store) {
      try {
        var miniCart = Alpine.store("xMiniCart");

        if (miniCart && typeof miniCart.openCart === "function") {
          miniCart.openCart();
        }
      } catch (error) {
        console.warn("Unable to open mini cart:", error);
      }

      try {
        var helper = Alpine.store("xCartHelper");
        var bubble = document.querySelector("#cart-icon-bubble span");

        if (helper && bubble) {
          helper.currentItemCount =
            parseInt(bubble.textContent, 10) || helper.currentItemCount;
        }
      } catch (error) {
        console.warn("Unable to update cart count:", error);
      }
    }

    var cartDrawer = document.querySelector("cart-drawer");

    if (cartDrawer && typeof cartDrawer.open === "function") {
      cartDrawer.open();
    }

    var drawerElement = document.querySelector(
      "#CartDrawer, cart-drawer, .cart-drawer, [data-cart-drawer]",
    );

    if (drawerElement) {
      drawerElement.classList.add("active", "is-open", "animate");

      drawerElement.removeAttribute("hidden");
      drawerElement.setAttribute("open", "");
    }
  }

  function refreshCartBubble() {
    return fetch(cartRoute("/cart.js"), {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var count = parseInt(cart.item_count, 10) || 0;

        var bubbleSelectors = [
          "#cart-icon-bubble span",
          "#mobile-cart-icon-bubble span",
          "#cart-icon-bubble-mobile-dock span",
          "cart-count",
        ];

        bubbleSelectors.forEach(function (selector) {
          document.querySelectorAll(selector).forEach(function (bubble) {
            bubble.textContent = count;

            if (bubble.hasAttribute("aria-label")) {
              bubble.setAttribute("aria-label", count + " items");
            }

            bubble.toggleAttribute("hidden", count === 0);
          });
        });

        document
          .querySelectorAll(
            "#cart-icon-bubble, #mobile-cart-icon-bubble, #cart-icon-bubble-mobile-dock",
          )
          .forEach(function (wrapper) {
            wrapper.classList.toggle("hidden", count === 0);
          });

        return cart;
      })
      .catch(function () {
        return null;
      });
  }

  function setButtonText(button, text) {
    if (!button || !text) return;

    var textTarget = button.querySelector("span");

    if (textTarget) {
      textTarget.textContent = text;
    } else {
      button.textContent = text;
    }
  }

  function getSectionAddLabel(section) {
    return (
      section.dataset.addButtonLabel || section.dataset.addLabel || "Add Sample"
    );
  }

  function getSectionAddedLabel(section) {
    return section.dataset.addedLabel || "Added";
  }

  function getSectionSoldOutLabel(section) {
    return section.dataset.soldOutLabel || "Sold out";
  }

  function initializeSampleButtons(root) {
    toArray(root.querySelectorAll("[data-sample-add]")).forEach(
      function (button) {
        if (!button.hasAttribute("data-sample-original-disabled")) {
          button.dataset.sampleOriginalDisabled = button.disabled
            ? "true"
            : "false";
        }
      },
    );
  }

  function markVariantAdded(section, variantId) {
    var addedLabel = getSectionAddedLabel(section);

    toArray(
      section.querySelectorAll(
        '[data-sample-card][data-variant-id="' + variantId + '"]',
      ),
    ).forEach(function (card) {
      card.classList.add("is-added");

      var button = card.querySelector("[data-sample-add]");

      if (button) {
        setButtonText(button, addedLabel);
        button.setAttribute("aria-label", addedLabel);
      }
    });
  }

  function resetVariantAdded(section, variantId) {
    var addLabel = getSectionAddLabel(section);
    var soldOutLabel = getSectionSoldOutLabel(section);

    toArray(
      section.querySelectorAll(
        '[data-sample-card][data-variant-id="' + variantId + '"]',
      ),
    ).forEach(function (card) {
      card.classList.remove("is-added");

      var button = card.querySelector("[data-sample-add]");

      if (!button) return;

      var wasOriginallyDisabled =
        button.dataset.sampleOriginalDisabled === "true";

      if (wasOriginallyDisabled) {
        button.disabled = true;
        setButtonText(button, soldOutLabel);
        button.setAttribute("aria-label", soldOutLabel);
      } else {
        button.disabled = false;
        setButtonText(button, addLabel);
        button.setAttribute("aria-label", addLabel);
      }
    });
  }

  function getCartVariantIdMap(cart) {
    var map = {};

    if (!cart || !Array.isArray(cart.items)) return map;

    cart.items.forEach(function (item) {
      if (item && item.variant_id) {
        map[String(item.variant_id)] = true;
      }
    });

    return map;
  }

  function syncSectionWithCart(section, cart) {
    if (!section || !cart) return;

    var variantMap = getCartVariantIdMap(cart);

    toArray(
      section.querySelectorAll("[data-sample-card][data-variant-id]"),
    ).forEach(function (card) {
      var variantId = String(card.getAttribute("data-variant-id") || "");

      if (!variantId) return;

      if (variantMap[variantId]) {
        markVariantAdded(section, variantId);
      } else {
        resetVariantAdded(section, variantId);
      }
    });
  }

  function syncAllSampleSectionsWithCart(cart) {
    toArray(document.querySelectorAll("[data-sample-tabs-section]")).forEach(
      function (section) {
        syncSectionWithCart(section, cart);
      },
    );
  }

  function fetchAndSyncSampleCards() {
    return fetch(cartRoute("/cart.js"), {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        syncAllSampleSectionsWithCart(cart);
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

  function scheduleSampleCartSync() {
    window.clearTimeout(cartSyncTimer);

    cartSyncTimer = window.setTimeout(function () {
      fetchAndSyncSampleCards();
    }, 150);
  }

  function bindCartRemoveSyncEvents() {
    if (window._sampleTabsCartRemoveSyncBound) return;

    window._sampleTabsCartRemoveSyncBound = true;

    document.addEventListener(
      "cart:updated",
      function (event) {
        var cart = event && event.detail ? event.detail.cart : null;

        if (cart && Array.isArray(cart.items)) {
          syncAllSampleSectionsWithCart(cart);
        } else {
          scheduleSampleCartSync();
        }
      },
      true,
    );

    document.addEventListener(
      "eurus:cart:items-changed",
      function () {
        scheduleSampleCartSync();
      },
      true,
    );

    document.addEventListener(
      "cart:refresh",
      function () {
        scheduleSampleCartSync();
      },
      true,
    );
  }

  function addVariantToCart(section, button) {
    ensureThemeFallbackStores();

    if (!button || button.disabled) return;

    var variantId = button.getAttribute("data-variant-id");

    if (!variantId) return;

    var sectionsToRender = getCartSectionsToRender();

    var sectionIds = sectionsToRender.map(function (sectionToRender) {
      return sectionToRender.id;
    });

    button.disabled = true;
    button.classList.add("is-loading");

    fetch(cartRoute("/cart/add.js"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        sections: sectionIds,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (error) {
            throw error;
          });
        }

        return response.json();
      })
      .then(function (response) {
        markVariantAdded(section, variantId);

        return reRenderCartSections(response.sections)
          .then(refreshCartBubble)
          .then(function (cart) {
            publishCartEvents(cart || response);
            syncAllSampleSectionsWithCart(cart || response);

            window.setTimeout(function () {
              openCartDrawer();
            }, 100);
          });
      })
      .catch(function (error) {
        console.error("Sample add error:", error);

        alert(
          error && error.description
            ? error.description
            : section.dataset.errorMessage || "Unable to add this sample.",
        );
      })
      .finally(function () {
        var wasOriginallyDisabled =
          button.dataset.sampleOriginalDisabled === "true";

        button.disabled = wasOriginallyDisabled;
        button.classList.remove("is-loading");
      });
  }

  function findGroupById(root, groupId) {
    var groups = toArray(root.querySelectorAll("[data-sample-group]"));

    for (var index = 0; index < groups.length; index += 1) {
      if (groups[index].getAttribute("data-sample-group") === groupId) {
        return groups[index];
      }
    }

    return null;
  }

  function appendUniqueSampleCards(section, currentGrid, incomingGrid) {
    var existingVariantIds = {};

    toArray(
      currentGrid.querySelectorAll("[data-sample-card][data-variant-id]"),
    ).forEach(function (card) {
      existingVariantIds[String(card.getAttribute("data-variant-id"))] = true;
    });

    var appendedCount = 0;

    toArray(incomingGrid.querySelectorAll("[data-sample-card]")).forEach(
      function (incomingCard) {
        var variantId = String(
          incomingCard.getAttribute("data-variant-id") || "",
        );

        if (variantId && existingVariantIds[variantId]) {
          return;
        }

        existingVariantIds[variantId] = true;

        var importedCard = document.importNode(incomingCard, true);

        currentGrid.appendChild(importedCard);
        appendedCount += 1;
      },
    );

    if (appendedCount > 0) {
      initializeSampleButtons(currentGrid);
      scheduleSampleCartSync();
    }

    return appendedCount;
  }

  function loadMoreSamples(section, loader) {
    if (!section || !loader || loader.dataset.loading === "true") {
      return;
    }

    var nextUrl = loader.getAttribute("data-next-url");
    var groupId = loader.getAttribute("data-group-id");

    if (!nextUrl || !groupId) {
      loader.hidden = true;
      return;
    }

    var currentGroup = findGroupById(section, groupId);

    if (!currentGroup) {
      loader.hidden = true;
      return;
    }

    var currentGrid = currentGroup.querySelector(".sample-tabs__grid");

    if (!currentGrid) {
      loader.hidden = true;
      return;
    }

    loader.dataset.loading = "true";
    loader.classList.add("is-loading");
    loader.removeAttribute("hidden");

    fetch(nextUrl, {
      method: "GET",
      headers: {
        Accept: "text/html",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Unable to load additional samples.");
        }

        return response.text();
      })
      .then(function (html) {
        var parsedDocument = new DOMParser().parseFromString(html, "text/html");

        var incomingSection = parsedDocument.querySelector(
          '[data-sample-tabs-section][data-section-id="' +
            section.dataset.sectionId +
            '"]',
        );

        if (!incomingSection) {
          throw new Error("Unable to locate the sample section.");
        }

        var incomingGroup = findGroupById(incomingSection, groupId);

        if (!incomingGroup) {
          throw new Error("Unable to locate the sample group.");
        }

        var incomingGrid = incomingGroup.querySelector(".sample-tabs__grid");

        if (!incomingGrid) {
          throw new Error("Unable to locate additional sample cards.");
        }

        var appendedCount = appendUniqueSampleCards(
          section,
          currentGrid,
          incomingGrid,
        );

        var incomingLoader = incomingGroup.querySelector(
          "[data-sample-load-more]",
        );

        var followingUrl = incomingLoader
          ? incomingLoader.getAttribute("data-next-url")
          : "";

        if (followingUrl && appendedCount > 0) {
          loader.setAttribute("data-next-url", followingUrl);

          if (!("IntersectionObserver" in window)) {
            window.setTimeout(function () {
              loadMoreSamples(section, loader);
            }, 0);
          }
        } else {
          loader.removeAttribute("data-next-url");
          loader.hidden = true;

          if (
            section._sampleInfiniteObserver &&
            typeof section._sampleInfiniteObserver.unobserve === "function"
          ) {
            section._sampleInfiniteObserver.unobserve(loader);
          }
        }
      })
      .catch(function (error) {
        console.error("Sample infinite scroll error:", error);

        loader.classList.add("has-error");

        window.setTimeout(function () {
          loader.classList.remove("has-error");
        }, 3000);
      })
      .finally(function () {
        loader.dataset.loading = "false";
        loader.classList.remove("is-loading");
      });
  }

  function initInfiniteSampleScroll(section) {
    if (!section || section.dataset.sampleInfiniteInitialized === "true") {
      return;
    }

    section.dataset.sampleInfiniteInitialized = "true";

    var loaders = toArray(
      section.querySelectorAll("[data-sample-load-more][data-next-url]"),
    );

    if (!loaders.length) return;

    if (!("IntersectionObserver" in window)) {
      loaders.forEach(function (loader) {
        loadMoreSamples(section, loader);
      });

      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          loadMoreSamples(section, entry.target);
        });
      },
      {
        root: null,
        rootMargin: "600px 0px",
        threshold: 0,
      },
    );

    loaders.forEach(function (loader) {
      observer.observe(loader);
    });

    section._sampleInfiniteObserver = observer;
  }

  function initDraggableTabsNav(section) {
    var nav = section.querySelector(".sample-tabs__nav");

    if (!nav || nav.dataset.sampleDragInitialized === "true") {
      return;
    }

    var startX = 0;
    var startScrollLeft = 0;
    var pointerId = null;
    var hasDragged = false;
    var ignoreClick = false;

    nav.dataset.sampleDragInitialized = "true";

    nav.addEventListener("pointerdown", function (event) {
      if (event.button !== undefined && event.button !== 0) {
        return;
      }

      if (nav.scrollWidth <= nav.clientWidth) return;

      pointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = nav.scrollLeft;
      hasDragged = false;
    });

    nav.addEventListener("pointermove", function (event) {
      if (pointerId !== event.pointerId) return;

      var deltaX = event.clientX - startX;

      if (!hasDragged && Math.abs(deltaX) > 8) {
        hasDragged = true;
        ignoreClick = true;
        nav.classList.add("is-dragging");
        nav.setPointerCapture(pointerId);
      }

      if (hasDragged) {
        event.preventDefault();
        nav.scrollLeft = startScrollLeft - deltaX;
      }
    });

    function stopDragging(event) {
      if (pointerId !== event.pointerId) return;

      nav.classList.remove("is-dragging");

      if (nav.hasPointerCapture && nav.hasPointerCapture(pointerId)) {
        nav.releasePointerCapture(pointerId);
      }

      pointerId = null;
    }

    nav.addEventListener("pointerup", stopDragging);
    nav.addEventListener("pointercancel", stopDragging);

    nav.addEventListener(
      "click",
      function (event) {
        if (!ignoreClick) return;

        event.preventDefault();
        event.stopPropagation();
        ignoreClick = false;
      },
      true,
    );
  }

  function initSampleTabs(section) {
    if (!section || section.dataset.sampleTabsInitialized === "true") {
      return;
    }

    section.dataset.sampleTabsInitialized = "true";

    initDraggableTabsNav(section);
    initInfiniteSampleScroll(section);
    initializeSampleButtons(section);

    toArray(section.querySelectorAll("[data-sample-tab]")).forEach(
      function (tab) {
        tab.addEventListener("click", function () {
          var target = tab.getAttribute("data-sample-tab");

          toArray(section.querySelectorAll("[data-sample-tab]")).forEach(
            function (item) {
              var active = item === tab;

              item.classList.toggle("is-active", active);

              item.setAttribute("aria-selected", active ? "true" : "false");
            },
          );

          if (target === "all") {
            toArray(section.querySelectorAll("[data-sample-group]")).forEach(
              function (group) {
                group.classList.add("is-visible");
              },
            );
          } else {
            toArray(section.querySelectorAll("[data-sample-group]")).forEach(
              function (group) {
                group.classList.toggle(
                  "is-visible",
                  group.getAttribute("data-sample-group") === target,
                );
              },
            );
          }
        });
      },
    );

    section.addEventListener("click", function (event) {
      var addButton = event.target.closest("[data-sample-add]");

      if (!addButton || !section.contains(addButton)) {
        return;
      }

      event.preventDefault();
      addVariantToCart(section, addButton);
    });
  }

  function initAllSampleTabs(root) {
    ensureThemeFallbackStores();
    bindCartRemoveSyncEvents();

    toArray(
      (root || document).querySelectorAll("[data-sample-tabs-section]"),
    ).forEach(initSampleTabs);

    scheduleSampleCartSync();
  }

  document.addEventListener("alpine:init", ensureThemeFallbackStores);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAllSampleTabs(document);
    });
  } else {
    initAllSampleTabs(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAllSampleTabs(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var section = event.target.querySelector("[data-sample-tabs-section]");

    if (section && section._sampleInfiniteObserver) {
      section._sampleInfiniteObserver.disconnect();
      section._sampleInfiniteObserver = null;
    }
  });
})();
